class VideoElement extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['video']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.videoEl, 'play', () => {
      this.playing = true
    })
    this.listeners.add(this.videoEl, 'pause', () => {
      this.playing = false
    })
    this.listeners.add(this.videoEl, 'ended', () => {
      this.playing = false
    })
  }

  get videoEl () {
    return this.els?.video?.element
  }

  get playing () {
    return this._playing
  }

  set playing (boolean) {
    this._playing = boolean
    this.setAttribute('data-playing', boolean)
  }
}

if (!customElements.get('video-element')) {
  customElements.define('video-element', VideoElement)
}
